/* SmileIn — RTL patch for the theme's <slider-component> (global.js).
   In RTL, scrollLeft is 0 at the start and negative while scrolling, and slide
   offsetLeft decreases. The step math survives (negative offset / negative
   scrollLeft), but slidesPerPage and the visibility check assume LTR.
   Patched on the prototype; LTR paths untouched. Loads after global.js (defer). */
(() => {
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  const Slider = customElements.get('slider-component');
  if (Slider && !Slider.prototype.__smileinRtl) {
    const proto = Slider.prototype;
    proto.__smileinRtl = true;

    proto.initPages = function () {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      const [a, b] = this.sliderItemsToShow;
      // Negative in RTL: keeps the "scrollLeft ± step * offset" math moving forward.
      this.sliderItemOffset = b.offsetLeft - a.offsetLeft;
      const step = Math.abs(this.sliderItemOffset) || 1;
      const available = a.offsetLeft + a.clientWidth - this.slider.offsetLeft;
      this.slidesPerPage = Math.max(1, Math.floor(available / step));
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    };

    proto.isSlideVisible = function (element, offset = 0) {
      const left = element.offsetLeft - this.slider.offsetLeft;
      const right = left + element.clientWidth;
      const start = this.slider.scrollLeft;
      return left >= start - 1 && right <= start + this.slider.clientWidth - offset + 1;
    };
  }

  // Elements upgraded before this file ran: recompute with the patched math.
  document.querySelectorAll('slider-component').forEach((el) => {
    if (typeof el.initPages === 'function' && el.slider) el.initPages();
  });
})();
